import script from "./WaizmannWertKrank.vue?vue&type=script&setup=true&lang=js"
export * from "./WaizmannWertKrank.vue?vue&type=script&setup=true&lang=js"

import "./WaizmannWertKrank.vue?vue&type=style&index=0&id=2fac8e5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fac8e5c"]])

export default __exports__